import {
  DirectSale,
  DirectSaleStatusEnum,
} from '@/core/domain/sales/DirectSale/DirectSale.types';
import { useDisclosure } from '@/hooks';
import React from 'react';
import DirectSaleGenerateTaxCouponModal from '../DirectSaleGenerateTaxCouponModal';
import { Button } from 'antd';
import { InvoiceDTO } from '@/core/domain/invoice/invoice/Invoice.types';
import { useTaxCouponList } from '@/core/domain/coupon/coupons/coupons.hooks';
import { CouponOriginEntity } from '@/core/domain/coupon/coupons/coupons.types';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';

interface Props {
  directSale?: DirectSale;
  invoiceData?: InvoiceDTO[];
}
const DirectSaleTaxCouponButton: React.FC<Props> = ({
  directSale,
  invoiceData,
}) => {
  const [taxCouponModalOpened, taxCouponModalAction] = useDisclosure();

  const { data: taxCouponsData } = useTaxCouponList({
    companyId: directSale?.companyId,
    entity: CouponOriginEntity.SALES,
    entityCode: directSale ? [directSale.saleCode] : undefined,
    entityId: directSale ? [String(directSale.id)] : undefined,
  });

  const taxCoupons = flatInfiniteData(taxCouponsData);
  const hasTaxCoupons = !!taxCoupons.length;

  return (
    <>
      {!hasTaxCoupons &&
        directSale?.status === DirectSaleStatusEnum.AUTHORIZED &&
        !invoiceData?.length && (
          <Button block type="primary" onClick={taxCouponModalAction.open}>
            Gerar cupom fiscal
          </Button>
        )}

      {hasTaxCoupons && (
        <Button
          block
          type="primary"
          onClick={() =>
            window.open(
              `/app/fiscal/cfe/${taxCoupons[0].id}/${directSale?.companyId}/general`,
              '_blank',
            )
          }
        >
          Emitir cupom fiscal
        </Button>
      )}

      <DirectSaleGenerateTaxCouponModal
        open={taxCouponModalOpened}
        onClose={taxCouponModalAction.close}
        directSale={directSale}
      />
    </>
  );
};

export default DirectSaleTaxCouponButton;
